export default "__VITE_ASSET__JXfJzT6e__"